export default __webpack_public_path__ + "static/media/logo-icon.607ccd89.svg";